export default __webpack_public_path__ + "8c837716d316500cf98ebf4b7cb813b4.jpeg";